/**
 * @generated SignedSource<<b79e5bd56d584876e3084d10ea24c8b8>>
 * @relayHash 949ec93e2e750573480678a72afd0b2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9abcf8b8bdce61a01169ab458d5e031dab509316cdf48a38da7f2646c97dea15

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type initialMentionAgentsQuery$variables = {
  allFirst: number;
  cloudId: string;
  favouritesFirst: number;
  product?: string | null;
  verifiedFirst: number;
  workspaceId?: string | null;
};
export type initialMentionAgentsQuery$data = {
  readonly all: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"mapEdgeToAgent">;
      } | null;
    }>;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly favourites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"mapEdgeToAgent">;
      } | null;
    }>;
  } | null;
  readonly verified: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"mapEdgeToAgent">;
      } | null;
    }>;
  } | null;
};
export type initialMentionAgentsQuery = {
  response: initialMentionAgentsQuery$data;
  variables: initialMentionAgentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allFirst"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouritesFirst"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "verifiedFirst"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v7 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v8 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v9 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "favouritesFirst"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyFavouriteAgents": true
    }
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "description"
},
v13 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v14 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v15 = {
  "kind": "ScalarField",
  "name": "creatorType"
},
v16 = {
  "kind": "ScalarField",
  "name": "picture"
},
v17 = {
  "concreteType": "AgentStudioAgentEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "AgentStudioAssistant",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "mapEdgeToAgent",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v10/*: any*/),
                (v11/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "identityAccount",
                      "plural": false,
                      "selections": [
                        (v10/*: any*/),
                        (v16/*: any*/)
                      ]
                    }
                  ],
                  "type": "AgentStudioAssistant"
                }
              ],
              "type": "AgentStudioAgent",
              "abstractKey": "__isAgentStudioAgent"
            }
          ],
          "argumentDefinitions": ([]/*: any*/)
        }
      ]
    }
  ]
},
v18 = [
  (v17/*: any*/)
],
v19 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "verifiedFirst"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyVerifiedAgents": true
    }
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v20 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "allFirst"
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v21 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v22 = {
  "concreteType": "AgentStudioAgentEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "AgentStudioAssistant",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v11/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "identityAccount",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    (v10/*: any*/),
                    (v16/*: any*/)
                  ]
                }
              ],
              "type": "AgentStudioAssistant"
            }
          ],
          "type": "AgentStudioAgent",
          "abstractKey": "__isAgentStudioAgent"
        }
      ]
    }
  ]
},
v23 = [
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "initialMentionAgentsQuery",
    "selections": [
      {
        "alias": "favourites",
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "alias": "verified",
        "args": (v19/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v18/*: any*/)
      },
      {
        "alias": "all",
        "args": (v20/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v17/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "initialMentionAgentsQuery",
    "selections": [
      {
        "alias": "favourites",
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v23/*: any*/)
      },
      {
        "alias": "verified",
        "args": (v19/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v23/*: any*/)
      },
      {
        "alias": "all",
        "args": (v20/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v22/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "9abcf8b8bdce61a01169ab458d5e031dab509316cdf48a38da7f2646c97dea15",
    "metadata": {},
    "name": "initialMentionAgentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6d7fccabc8a52038fa7c5d9dd5cbf22e";

export default node;
